import badgeGoogleSrc from '~/src/assets/images/app/badge-google.png';

const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=fr.monmarche.app&pli=1';

interface Props {
  className?: string;
  onClick?: () => void;
}

export const GooglePlayBadge = (props: Props) => (
  <a
    className={props.className}
    href={GOOGLE_PLAY_URL}
    target="_blank"
    rel="noopener noreferrer"
    onClick={props.onClick}>
    <img src={badgeGoogleSrc} alt="Google Play Badge" />
  </a>
);
